<script lang="ts">
import {defineComponent} from 'vue';
import {useRouter} from 'vue-router';
import type {IHouse} from '../api';
import {useLocale} from '~/plugins/Localization';

export default defineComponent({
  name: 'RealtySecondHouses',
  props: {
    list: {
      type: Object as PropType<IHouse[]>,
    },
    uuid: {
      type: String as any,
    },
    name: String,
  },
  setup(props) {
    console.debug({props});
    const router = useRouter();
    const route = useRoute();
    const locale = useLocale();
    watch(
      () => props.list,
      (list) => {
        if (props.list?.length === 1) {
          console.debug(props.list[0]);
          router.push({
            name: 'Realty',
            query: {
              street: props.list[0].street,
              house_uuid: props.list[0].uuid,
              secondaryPathName: locale.getRealty(props.list[0].name),
              entrances: props.list[0].entrances.length
                ? 'yes'
                : 'no',
              nameRC: route.query.nameRC,
            },
          });
        }
      },
    );
    function openFlats(
      house_uuid: string,
      name: string,
      info: IHouse,
    ) {
      router.push({
        query: {
          house_uuid,
          secondaryPathName: props.name,
          tetriaryRouteName: name,
          entrances: info.entrances.length ? 'yes' : 'no',
          street: info.street,
          nameRC: route.query.nameRC,
        },
      });
    }
    return {
      openFlats,
    };
  },
});
</script>

<template>
  <section :class="['realty', 'scroll-container', 'realty--houses']">
    <div class="realty__list">
      <div
        v-for="house in list"
        :key="house.uuid"
        class="realty-second-house"
      >
        <img class="image" :src="house.preview" />
        <div class="wrapper-main-info">
          <div>
            <div class="title">
              {{ $realty(house.name) }}
            </div>
          </div>
        </div>
        <div class="action">
          <ui-button
            class="btn"
            :label="$t('open')"
            color="gray"
            @click="openFlats(house.uuid, $realty(house.name), house)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.realty__list {
  width: 100%;
  max-width: 1128px;
  min-height: 576px;
  margin: 0 auto 0;
  @include grid-card-center;

  .realty-second-house {
    width: 264px;
    height: 274px;
    padding: 18px;
    border-radius: 16px;
    border: 1px solid var(--white-theme-white-400, #e1e5f0);
    background: var(--white-theme-white-200, #f6f8fd);
    display: flex;
    flex-direction: column;

    &.preload {
      .image {
        background: linear-gradient(
          107.15deg,
          #192734 36.98%,
          #273b4f 49.48%,
          #192734 61.46%
        );
        animation: 1.5s shine linear infinite;
        background-size: 200% 100%;
      }

      .wrapper-main-info {
        .title {
          background: linear-gradient(
            107.15deg,
            #192734 36.98%,
            #273b4f 49.48%,
            #192734 61.46%
          );
          border-radius: 4px;
          width: 100%;
          height: 16px;
          background-size: 200% 100%;
          animation: 1.5s shine linear infinite;
        }

        .meta-info {
          margin-top: 8px;
          background: linear-gradient(
            107.15deg,
            #192734 36.98%,
            #273b4f 49.48%,
            #192734 61.46%
          );
          animation: 1.5s shine linear infinite;
          background-size: 200% 100%;
          border-radius: 4px;
          background-color: var(--bg-secondary);
          width: 100%;
          height: 16px;
        }
      }
    }

    .image {
      width: 100%;
      height: 142px;
      border-radius: 8px;
      background-size: cover;
      background-position: center;
      transition: all 0.2s ease;
      margin-bottom: 16px;
      object-fit: cover;
    }

    .action {
      margin-top: auto;
      padding-top: 16px;
    }

    .info-btn {
      width: 24px;
      min-width: 24px;
      height: 24px;
      cursor: pointer;

      svg {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
        fill: #7f97aa;
      }

      &:hover {
        svg {
          fill: #fff;
        }
      }
    }

    .wrapper-main-info {
      width: 100%;
      display: flex;
      justify-content: space-between;

      div {
        text-align: left;
      }

      .title {
        color: var(--white-theme-black-100, #3d424a);
        font-family: Segoe UI;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.32px;
        align-items: center;
        position: relative;
        display: flex;
        white-space: nowrap;
        // &:after {
        //   position: absolute;
        //   right: 0;
        //   height: 100%;
        //   width: 50px;
        //   background: linear-gradient(
        //       90deg,
        //       transparent 0,
        //       var(--bg-quinary) 100%
        //   );
        //   content: '';
        // }
      }

      .meta-info {
        display: flex;
        margin-top: 4px;

        .name-param {
          margin-right: 24px;
          width: 64px;
          height: 16px;
          color: var(--white-theme-gray-200, #839aaf);
          font-family: Segoe UI;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        .value-param {
          color: var(--white-theme-black-200, #64686e);
          font-family: Segoe UI;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
    .btn {
      width: 100%;
    }
  }
}
</style>
